import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const setRobots = (content) => {
  let el = document.head.querySelector('meta[name="robots"]');
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', 'robots'); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

// Soft-404 page for unknown routes: noindex, no canonical, no redirect.
export const NotFoundPage = () => {
  useEffect(() => {
    document.title = 'Page not found — OnlyMass';
    setRobots('noindex');
    document.head.querySelector('link[rel="canonical"]')?.remove();
    document.head.querySelector('meta[property="og:url"]')?.remove();
  }, []);

  return (
    <main data-testid="not-found-page" className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-6">
      <div className="max-w-md text-center space-y-5">
        <img src="/brand/logo-icon.png" alt="OnlyMass" className="w-14 h-14 rounded-xl mx-auto" />
        <p className="text-sm font-semibold text-blue-600 uppercase tracking-wider">404</p>
        <h1 data-testid="not-found-title" className="text-3xl font-bold text-[#0f1d3d] dark:text-white">Page not found</h1>
        <p className="text-slate-600 dark:text-slate-300">The page you're looking for doesn't exist or may have moved.</p>
        <div className="flex items-center justify-center gap-3 pt-2">
          <Link to="/" data-testid="not-found-home-link" className="px-5 py-2.5 rounded-lg bg-[#0f1d3d] dark:bg-blue-600 text-white text-sm font-medium hover:opacity-90 transition-opacity">
            Go to OnlyMass homepage
          </Link>
          <Link to="/support" data-testid="not-found-support-link" className="px-5 py-2.5 rounded-lg border border-slate-300 dark:border-slate-700 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-slate-900 transition-colors">
            Visit Support
          </Link>
        </div>
      </div>
    </main>
  );
};
